import { placeholderPlotCss } from "./DataSnippet.css"

export function PlaceholderPlot() {
  return (
    <svg
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={placeholderPlotCss}
    >
      <rect
        x="0.5"
        y="0.5"
        width="53"
        height="53"
        rx="3.5"
        stroke="currentColor"
      />
      <line
        x1="14.065"
        y1="39.728"
        x2="40.2279"
        y2="13.565"
        stroke="currentColor"
      />
      <line
        x1="40.2279"
        y1="40.4351"
        x2="14.065"
        y2="14.2721"
        stroke="currentColor"
      />
    </svg>
  )
}
